// import { Link } from 'react-router-dom';
import styled from 'styled-components';
export const ContainerFluid = styled.div`
// border:2px dashed red;
width:100%;
min-height:257px;
background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1657123691/re-brand/Vector_vpsad6.svg');
background-size:contain;
background-repeat:no-repeat;
background-position:top right;

`;

export const ContainerFluidB = styled.div`
// border:2px dashed red;
width:100%;
`;

export const ContainerFluidC = styled.div`
// border:2px dashed red;
margin-top:-250px;
width:100%;
min-height:468px;
background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1657126424/re-brand/Frame_sfvqnr.svg');
background-size:contain;
background-repeat:no-repeat;
background-position:top right;
@media screen and (max-width: 425px) {
  width:auto !important;
  background-size:cover;
}
`;


export const Container = styled.div
.attrs(() => ({
  className: 'container-custom',
}))`
`;

export const HeadingText = styled.h1
.attrs(() => ({
  className: '',
}))`
font-family: 'Cabinet Grotesk-regular', roboto;
font-style: normal;
font-weight: 700;
font-size: 36px;
line-height: 103%;
color: #282828;
margin-bottom:0px !important;
@media screen and (max-width: 425px) {
    width:auto !important;
}

`;
export const ParagraphText = styled.p
.attrs(() => ({
  className: '',
}))`

font-family: 'Cabinet Grotesk-regular', roboto;
font-style: normal;
font-weight: 800;
font-size:20px;
line-height: 142.5%;
color: #4A4A4A;
b{
font-family: 'Cabinet Grotesk-b', roboto;
font-weight: 500;
}
@media screen and (max-width: 425px) {
    width:auto !important;
}

`;